import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';

export interface WeatherCity {
  city_name: string;
  wind_speed: number;
  ghi: number;
  data_type: string;
  time: string;
}

export interface WeatherCitiesResponse {
  data: {
    cities: WeatherCity[];
  };
}

export function useWeatherCities() {
  return useQuery({
    queryKey: ['weather', 'cities'],
    queryFn: async () => {
      const res = await apiClient.get<WeatherCitiesResponse>('/weather/cities');
      return res.data.data;
    },
    staleTime: 120 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
